import "./styles.css";

/** Loading skeleton during /forms/v0/tokens/validate (UI-SPEC §State 1). */
export function FormSkeleton() {
  return (
    <div className="form-card" aria-busy="true" aria-label="Loading form">
      <div className="skeleton-bar" style={{ height: 40, width: 120, marginBottom: 24 }} />
      <div className="skeleton-bar" style={{ height: 20, width: "60%", marginBottom: 16 }} />
      <div className="skeleton-bar" style={{ height: 13, width: "30%", marginBottom: 8 }} />
      <div className="skeleton-bar" style={{ height: 44, width: "100%", marginBottom: 16 }} />
      <div className="skeleton-bar" style={{ height: 13, width: "30%", marginBottom: 8 }} />
      <div className="skeleton-bar" style={{ height: 44, width: "100%" }} />
    </div>
  );
}
